import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, OBJECT } from '@/plugins/sdk/fields'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'file'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      type: new STRING(),
      file: new OBJECT(),
      repository: new STRING(),
      downloads: new STRING(),
      is_shared: new BOOLEAN(),
      is_public: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      creator: new ITEM(Profile)
    }
  }
}
